import React from 'react';
import ArchivoSubido from './ArchivoSubido';
import UploadService from '../../../services/upload-files';

const archivosSubidos = (props) => {
    const archivosAMostrar = props.fileInfos.filter(
        (archivo) =>
            !archivo.hasOwnProperty('bajaLogica') || !archivo.bajaLogica
    );

    const descargarArchivo = (archivo) => {
        UploadService.descargarAdjunto(
            archivo.pathArchivo,
            archivo.nombreArchivo
        );
    };

    const archivos = archivosAMostrar.map((file, index) => {
        if (file.bajaLogica) {
            return null;
        }

        return (
            <ArchivoSubido
                key={file.pathArchivo}
                fileName={file.nombreArchivo}
                borrar={() => props.borrarArchivos(file.pathArchivo, index)}
                deshabilitadoBorrar={props.deshabilitado}
                mostrarIcono={index > 0 ? false : true}
                descargarArchivoHandler={() => descargarArchivo(file)}
            />
        );
    });

    return <>{archivos}</>;
};

export default archivosSubidos;
